import { render, staticRenderFns } from "./AppReposPanel.vue?vue&type=template&id=62bd7e7c&scoped=true"
import script from "./AppReposPanel.vue?vue&type=script&lang=ts"
export * from "./AppReposPanel.vue?vue&type=script&lang=ts"
import style0 from "./AppReposPanel.vue?vue&type=style&index=0&id=62bd7e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd7e7c",
  null
  
)

export default component.exports